import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

export default function App() {
  return (
    <div
      className="d-flex justify-content-center align-items-center min-vh-100 text-center px-3"
      style={{ backgroundColor: "#f8f9fa" }}
    >
      <div className="domain-notice">
        <p className="mb-0">
          This domain has changed to another domain. Contact
          <br />
          <strong>Md: Rokunuzzaman Rokon</strong>
          <br />
          at Innovate Solution.
        </p>
      </div>
    </div>
  );
}
